export default __webpack_public_path__ + "static/media/fatty.d7ea0baa.svg";